
import { defineComponent, reactive, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import ServicoFormacaoPreco from '@/servicos/Cadastros/Precificacao/ServicoFormacaoPreco';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import FormacaoPrecoModal from './FormacaoPrecoModal.vue';
import AplicarFormacaoPrecoModal from './AplicarFormacaoPrecoModal.vue';
import Icone from '@/core/components/Icone.vue';

export default defineComponent({
  name: 'FormacaoPreco',
  components: {
    TelaPadraoCrud,
    FormacaoPrecoModal,
    AplicarFormacaoPrecoModal,
    Icone,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoFormacaoPreco = new ServicoFormacaoPreco();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    const state = reactive({
      exibirAplicacao: false,
    });

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = false;
    crudBase.estrutura.apresentarAcaoDuplicarGrade = true;
    crudBase.estrutura.verificarCadastroCompartilhado = false;
    crudBase.estrutura.apresentarAcaoImportar = false;
    crudBase.estrutura.botaoPrincipalAcao = 'Nova';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão do formação de preço:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 0, visible: false, ordering: true,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'Descricao', position: 1, visible: true, ordering: true, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Margem de Lucro', dataIndex: 'margemLucroFormatada', key: 'MargemLucroFormatada', position: 2, visible: true, width: 150, align: 'right', customRenderRow: ECustomRenderRow.MascararFracionado,
      },
      {
        title: 'Ações', key: 'acoes', position: 4, visible: true, width: 120, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'Codigo', ordem: 'DESC' } as IOrdenacao);

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    function abrirAplicacao() {
      state.exibirAplicacao = true;
    }

    return {
      state,
      crudBase,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
      servicoFormacaoPreco,
      refCrud,
      abrirAplicacao,
    };
  },
});
